import { useCustomViewDialogStore } from "csi/middleware/customView/CustomViewDialogStore";
import { isDefined } from "csi/utility/coreUtility";
import { Box, FlexColumn, SingleSelect } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import css from "src/csi/middleware/customView/options/CustomViewOptions.module.css";
import TimelineCustomViewOptionsStore from "./TimelineCustomViewOptionsStore";

const TimelineOptions: FunctionComponent = observer(function TimelineOptions() {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		onChangeSelectedTimelineRange,
		onChangeSelectedTimelineWeeks,
		selectedTimelineRange,
		selectedTimelineWeeks,
		timelineDropDownOptions,
	} = optionsStore as TimelineCustomViewOptionsStore;

	return (
		<>
			{isDefined(selectedTimelineRange) && (
				<Box className={css.container}>
					<FlexColumn 
						className={css.optionLeft}
						data-csi-automation="CustomViewTimelineRange"
					>
						<SingleSelect
							disableClearable
							fullWidth
							labelRes="CustomViewTimelineRange"
							onChange={onChangeSelectedTimelineRange}
							options={timelineDropDownOptions.timelineRangeOptions}
							value={selectedTimelineRange}
						/>
					</FlexColumn>
				</Box>
			)}
			{isDefined(selectedTimelineWeeks) && (
				<Box className={css.container}>
					<FlexColumn 
						className={css.optionLeft}
						data-csi-automation="CustomViewTimelineWeeks"
					>
						<SingleSelect
							disableClearable
							fullWidth
							labelRes="CustomViewTimelineWeeks"
							onChange={onChangeSelectedTimelineWeeks}
							options={timelineDropDownOptions.timelineWeeksOptions}
							value={selectedTimelineWeeks}
						/>
					</FlexColumn>
				</Box>
			)}
		</>
	);
});

export default TimelineOptions;